import { ROW_HIGHLIGHTED_COLOR } from "src/config/constants/genericConstants";

const formatMarginImpactData = (data: any) => {
  const createStyledCell = (value: any, style: any) => ({
    value,
    bold: style?.bold,
    underline: style?.underline,
    highlightColor: style?.highlight && ROW_HIGHLIGHTED_COLOR
  });

  return data?.map((parentItem: any) => ({
    title: { value: parentItem.title },
    isGrossMarginCollapsibleRow: true,
    key: parentItem?.key,
    childRowData: parentItem?.items?.map((childItem: any) => ({
      title: createStyledCell(childItem?.text, childItem?.style),
      cost: createStyledCell(childItem?.cost, childItem?.style),
      retail: createStyledCell(childItem?.retail, childItem?.style),
      margin: createStyledCell(childItem?.margin, childItem?.style),
      deli: createStyledCell(childItem?.deli, childItem?.style),
      beerOrWine: createStyledCell(childItem?.beerorwine, childItem?.style),
      grocery: createStyledCell(childItem?.grocery, childItem?.style),
      frozen: createStyledCell(childItem?.frozen, childItem?.style),
      hbc: createStyledCell(childItem?.hbc, childItem?.style),
      gm: createStyledCell(childItem?.gm, childItem?.style),
      produce: createStyledCell(childItem?.produce, childItem?.style),
      meat: createStyledCell(childItem?.meat, childItem?.style),
      level: childItem?.level,
      isHighlightedRow: childItem?.style?.bold,
      borderTop: childItem?.style?.bold
    }))
  }));
};

export default formatMarginImpactData;
